import { fetchTransport } from 'util/core/transport/fetch.transport'
import { type TagInterface } from './type/market-tag-type'
import { checkFetchError } from 'util/core/tool/check-fetch-error'

class DataAccessTags {
  public async getTags (pagintation?: boolean): Promise<any> {
    const params = new URLSearchParams()
    if (pagintation) {
      params.append('pagintation', String(pagintation))
    }
    const response = await fetchTransport.get({
      url: '/api/tags',
      searchParams: params
    })

    checkFetchError(response.status)

    const json = await response.json()
    let result = []

    if (json['@type'] === 'hydra:Collection') {
      if (json['hydra:member'].length > 0) {
        result = json['hydra:member']
      }
    }

    return result as TagInterface[]
  }
}

export const dataAccessTags = new DataAccessTags()
